/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { defaultPaths } from './default-paths';

const teamSettingsPaths = (base: string) => ({
  ...defaultPaths(base),
  billing: `${base}/billing`,
  members: `${base}/members`,
  settings: `${base}/settings`,
});

export { teamSettingsPaths };
